import './frontpage.scss';
import '../reportErrorForm';
import '../imageThemeUpdate';
import '../structure-page.scss';
import './aside/aside.js';
import './gallery/gallery';
import { applyStructurePreview } from '../../structure-preview/structure-preview';
import {applyStructureGallery} from "../../structures/frontpage/gallery/gallery";
import {useDraggableTable} from "@templates/components/table/table";
import { pubsub } from "@assets/js/imaios-global/imaios-global";
import { initializeQuickLinks } from "@assets/js/imaios-global/quick-links";
import { updateAsideTranslation } from "@templates/components/structures/frontpage/aside";
import { updateStructureDefinitionData } from "@templates/components/structure-edition/structure-edition";
import {
    initializeLanguageSwitcher
} from "@templates/components/structures/definition/languageSwitcher/languageSwitcher";
import { startEditorOnPageLoaded, initializeStructureEdition } from "@imaios-js/structure-definition-editor";
import { autoOpenHierarchyByLocation } from "@templates/components/structures/frontpage/aside/aside";
import { initReportForm } from "@templates/components/structures/reportErrorForm";

applyStructurePreview();
applyStructureGallery();
useDraggableTable('structure-definitionText', '#structure-definitionText .table-wrapper');

pubsub.subscribe(pubsub, "reloadApp", () => {
    applyStructurePreview();
    applyStructureGallery();

    //recall script of Translations image on Aside content
    updateAsideTranslation();

    //recall script button See more on Anatomical hierarchy
    imaios.pubsub.publish('hierarchy-created', document.getElementById('structures-hierarchy-list'));
    autoOpenHierarchyByLocation();

    //re Init quick-links
    initializeQuickLinks();

    //re init script Language Switcher & Structure Definition Editor
    updateStructureDefinitionData();
    initializeLanguageSwitcher();

    void startEditorOnPageLoaded();
    initializeStructureEdition();

    initReportForm();
});
